import { render, staticRenderFns } from "./FontResizer.vue?vue&type=template&id=de9baa0c&scoped=true"
import script from "./FontResizer.vue?vue&type=script&lang=js"
export * from "./FontResizer.vue?vue&type=script&lang=js"
import style0 from "./FontResizer.vue?vue&type=style&index=0&id=de9baa0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9baa0c",
  null
  
)

export default component.exports